/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypecodeplayground3Inputs */

const zh_learn_mistakestypecodeplayground3 = /** @type {(inputs: Learn_Mistakestypecodeplayground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代码练习`)
};

const en_learn_mistakestypecodeplayground3 = /** @type {(inputs: Learn_Mistakestypecodeplayground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Playground`)
};

const es_learn_mistakestypecodeplayground3 = /** @type {(inputs: Learn_Mistakestypecodeplayground3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código interactivo`)
};

/**
* | output |
* | --- |
* | "Code Playground" |
*
* @param {Learn_Mistakestypecodeplayground3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypecodeplayground3 = /** @type {((inputs?: Learn_Mistakestypecodeplayground3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypecodeplayground3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypecodeplayground3(inputs)
	if (locale === "en") return en_learn_mistakestypecodeplayground3(inputs)
	return es_learn_mistakestypecodeplayground3(inputs)
});
export { learn_mistakestypecodeplayground3 as "learn_mistakesTypeCodePlayground" }